import "./GlassyButton.css";
import { motion } from 'framer-motion';

export default function GlassyButton({ children, onClick, className = "", as = "button", delay = 1.25 }) {
    return (
        <motion.div
            initial={{opacity: 0, y: 16}}
            animate={{opacity: 1, y: 0}}
            transition={{
                duration: 0.5,
                delay: delay,
                ease: "easeInOut"
            }}
            className={`glassy-wrap ${className}`}
        >
                <div className="glassy-btn" onClick={onClick}>

                    <span className="glassy-ring" aria-hidden="true"/>

                    <div className="glassy-inner">
                        <span className="blob"></span>
                        <span className="blob"></span>
                        <span className="blob"></span>
                    </div>

                    <span className="glassy-label">{children}</span>
                </div>
        </motion.div>
    );
}
